import { useState } from "react";

/**
 * Custom hook for ANUploader.
 * @param {boolean} multi - If true, allows multiple files to be added.
 * @returns {Object} An object containing most of the necessary
 * functions and states for ANUploader component.
 */
const useANUploader = (multi = false) => {
  const [dropzoneFiles, setDropzoneFiles] = useState([]);

  const handleFileDelete = (file) => {
    setDropzoneFiles(dropzoneFiles.filter((dropzoneFile) => dropzoneFile !== file));
  };

  const handleFileUpload = (file) => {
    const acceptedFiles = file.acceptedFiles ?? [];
    const fileRejections = file.fileRejections ?? [];

    const nextFiles = [
      ...acceptedFiles.map((f) => ({ file: f, errors: false })),
      ...fileRejections.map((f) => ({ file: f, errors: true })),
    ];

    setDropzoneFiles((prev) => (multi ? [...prev, ...nextFiles] : nextFiles));
  };

  return {
    dropzoneFiles,
    setDropzoneFiles,
    handleFileDelete,
    handleFileUpload,
  };
};

export default useANUploader;
